import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import UserData from "../../models/UserData";
import usePlugin from "../Plugins/hooks/usePlugin";

export const PluginAdmin = ({ pluginId }) => {
  const [userData, setUserData] = useState(undefined);
  const { plugin } = usePlugin(pluginId);

  useEffect(() => {
    (async () => {
      if (plugin !== null) {
        const userData = new UserData(plugin.userId);
        await userData.fetch();
        setUserData(userData);
      }
    })();
  }, [plugin]);

  return (
    <div className="testing-area formContainer ">
      <h3>Admin - Plugin owner info</h3>
      {userData !== undefined && <p>{userData.data.name}</p>}
      {userData !== undefined && <p>{userData.data.email}</p>}
    </div>
  );
};
